<template>
  <div ref="root" class="sp-tab-panel" :class="classModifiers">
    <slot />
  </div>
</template>

<script setup>
import { computed, ref } from "vue";

import { useExpose } from "../../composables/expose";
import { toBoolean } from "../../utils/props";

const props = defineProps({
  name: {
    type: String,
    required: true,
  },
  active: {
    type: [Boolean, String],
    default: false,
  },
});

const root = ref(null);
const { exposeProperties } = useExpose(root);

const isActive = computed(() => toBoolean(props.active));

const classModifiers = computed(() => ({
  "--is-active": isActive.value,
}));

exposeProperties({
  name: () => props.name,
  active: () => isActive.value,
});
</script>

<style scoped lang="scss">
.sp-tab-panel {
  display: none;

  &.--is-active {
    display: block;
  }
}
</style>
